<template>
  <div class="resultados">
    <h2>
      <b>
        <span v-if="colegiados && (colegiados.length > 1 || colegiados.length === 0)">
          Total: {{ colegiados ? colegiados.length : 0 }} mandatos
        </span>
        <span v-else>
          Total: {{ colegiados ? colegiados.length : 0 }} mandato
        </span>
      </b>
    </h2>
    <table v-if="colegiados && colegiados.length > 0">
    
      <thead>
        <tr>
          <th>Órgão</th>
          <th>Nome do Colegiado</th>
          <th>Tipo do Colegiado</th>
          <th>Nome do Membro</th>
          <th>CPF do Membro</th>
          <th>Tipo do Membro</th>
          <th>Data Inicial do Mandato</th>
          <th>Data Final do Mandato</th>
          <th class="th-observacao">Obs.</th>
        </tr>
      </thead>
      <tbody>
        
        <template v-for="(colegiado, index) in colegiadosOrdenados">
          <template>
            <tr :key="colegiado.id + '-' + index" :class="[classesDeEstilo[index], 'linha-clicavel']" @click="irParaDetalhes(colegiado.colegiado_id || colegiado.id)">
              <td>{{ colegiado.orgao_nome }} — {{ colegiado.orgao_sigla }}</td>
              <td>{{ colegiado.colegiado_nome}}</td>
              <td>{{ getColegiadoNome(colegiado.colegiado_tipo) }}</td>
              <td>{{ colegiado.membro_nome ? colegiado.membro_nome.toUpperCase() : '' }}</td>
              <td>{{ formatarCPF(colegiado.cpf)}}</td>
              <td>{{ getTipo(colegiado.tipo_membro) }}</td>
              <td>{{ formatarData(colegiado.data_inicio) }}</td>
              <td>{{ formatarData(colegiado.data_termino) }}</td>
              
              <!-- Coluna da Observação com trava v-if - O .stop evita que a linha seja clicada quando clicar na seta -->
              <td class="td-observacao" @click.stop="toggleObservacao(index)">
                <span
                  v-if="colegiado.observacao && colegiado.observacao.trim() !== ''"
                  class="icone-tabela icone-observacao"
                  :title="linhasObservacaoAbertas[index] ? 'Ocultar observação' : 'Exibir observação'">
                  
                  <span v-if="linhasObservacaoAbertas[index]">&#x25BC;&#xFE0E;</span>
                  <span v-else>&#x25B6;&#xFE0E;</span>
                </span>
              </td>
            </tr>

            <!-- Linha Expansível -->
            <tr v-if="linhasObservacaoAbertas[index]" :key="'obs-' + colegiado.id + '-' + index" class="linha-observacao">
              <td colspan="9">
                <div class="conteudo-observacao">
                  <b>Observações:</b>
                  <span>{{ colegiado.observacao }}</span>
                </div>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
    <p v-else ><b class="sem-resultados">Nenhum resultado encontrado</b></p>
  </div>
</template>

<script>
  import { parseISO, format } from "date-fns"
  export default {
    props: ['colegiados', 'dias', 'ativarZebrado'],
    data() {
      return {
        linhasObservacaoAbertas: {}
      };
    },
    computed: {
      colegiadosOrdenados() {
        if (!this.colegiados) return [];
        
        return [...this.colegiados].sort((a, b) => {
          const remuneradoA = a.remunerado ? 1 : 0;
          const remuneradoB = b.remunerado ? 1 : 0;
          return remuneradoB - remuneradoA; 
        });
      },
      classesDeEstilo() {
        if (!this.colegiadosOrdenados) return [];

        if (!this.ativarZebrado) {
          return new Array(this.colegiadosOrdenados.length).fill('');
        }

        let classes = [];
        let isCinza = true;

        for (let i = 0; i < this.colegiadosOrdenados.length; i++) {
          if (i > 0) {
            const itemAtual = this.colegiadosOrdenados[i];
            const itemAnterior = this.colegiadosOrdenados[i - 1];

            if (itemAtual.orgao_nome !== itemAnterior.orgao_nome) {
              isCinza = !isCinza;
            }
          }
          classes.push(isCinza ? 'linha-cinza' : '');
        }
        return classes;
      }
    },
    methods: {
      irParaDetalhes(id) {
        this.$router.push({ name: 'ColegiadoShow', params: { id: id } });
      },
      toggleObservacao(index) {
        // Se a linha não tiver observação, não faz nada (proteção contra cliques fantasmas)
        if (!this.colegiadosOrdenados[index].observacao || this.colegiadosOrdenados[index].observacao.trim() === '') return;
        
        this.$set(this.linhasObservacaoAbertas, index, !this.linhasObservacaoAbertas[index]);
      },
      formatarData: function (value) {
        if (value == null) {
          return;
        }
        return format(parseISO(value), "dd/MM/yyyy");
      },
      formatarCPF(cpf) {
        cpf = cpf.replace(/\D/g, '');
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return cpf;
      },
      getColegiadoNome(numero) {
        const nomes = {
          0: 'Conselho',
          1: 'Comitê',
          2: 'Fórum',
          3: 'Diretoria',
          4: 'Câmara',
          5: 'Colégio',
          6: 'Junta'
        };
        return nomes[numero];
      },
      getTipo: function(value){
        if(value === 'titular'){
          return 'Titular';
        }
        else if(value === 'suplente'){
          return 'Suplente';
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

/* ========================================================================== */
/* Cabeçalho de Resultados ("Total: X mandatos")                              */
/* ========================================================================== */
.resultados h2 {
  font-size: 0.95rem;
  color: #bd0000;
  text-align: center;
  margin: 0 0 1rem 0;
  padding-top: 1rem;
  font-family: "Karla", sans-serif;
}

/* ========================================================================== */
/* Container da Tabela (Estilo Card Elevado Padrão)                           */
/* ========================================================================== */
.resultados > table {
  margin-top: 0.5rem;
  background: #ffffff;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
  overflow: hidden;
}

/* ========================================================================== */
/* Estilos de Célula e Cabeçalho (Fonte Karla, Cores SGU)                     */
/* ========================================================================== */
th, td {
  border: none !important;
  border-bottom: 1px solid #e7eee9 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem;
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

tbody tr:last-child td {
  border-bottom: none !important;
}

/* Estilização do cabeçalho Padrão SGU */
thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  border-right: 1px solid #a6c9b1 !important;
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  text-align: left;
}

thead th:last-child {
  border-right: none !important;
}

/* ========================================================================== */
/* Efeito Zebrado e Hover Integrado                                           */
/* ========================================================================== */
tbody tr {
  transition: background-color 0.15s ease;
  background-color: #ededed;
}

/* Linha Cinza Suave para contrastar */
tbody tr.linha-cinza {
  background-color: #ffffff !important;
}

.linha-clicavel {
  cursor: pointer;
}

/* Hover na cor verde institucional */
tbody tr.linha-clicavel:hover {
  background-color: rgba(0, 85, 22, 0.05) !important;
}

/* ========================================================================== */
/* Linha de Observação (Expandir / Recolher)                                  */
/* ========================================================================== */
.th-observacao,
.td-observacao {
  width: 3rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0 !important;
}

.icone-observacao {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent !important; 
  border: none !important;
  padding: 0.2rem;
}

.icone-observacao span {
  color: #005516 !important;
  font-size: 1.1rem !important;
  display: inline-block;
  line-height: 1;
}

.linha-observacao {
  background-color: #f7faf8 !important;
}

.linha-observacao td {
  text-align: left !important;
  border-top: none !important;
  padding: 0 !important;
}

.conteudo-observacao {
  padding: 0.8rem 1.5rem !important;
  font-size: 0.9rem !important;
  color: #3d4d44 !important;
  border-left: 4px solid #005516; 
  font-family: "Karla", sans-serif;
}

.conteudo-observacao b {
  color: #005516 !important;
  margin-right: 0.4rem !important;
}

/* ========================================================================== */
/* Tabela Vazia (Sem Resultados)                                              */
/* ========================================================================== */
.sem-resultados {
  text-align: center;
  padding: 2.5rem !important;
  color: #5f6f66;
  font-family: "Karla", sans-serif;
  font-size: 1rem;
  font-weight: normal;
}

/* ========================================================================== */
/* Responsividade e Alinhamentos Específicos                                  */
/* ========================================================================== */
@media screen and (min-width: 1066px) {
  .resultados {
    padding: 0.2rem;
  }
  tbody tr {
    text-align: left; /* Alinhamento padrão geral à esquerda */
    td {
      vertical-align: middle;
    }
    td:nth-child(1) { min-width: 12rem; }
    td:nth-child(5), td:nth-child(6), td:nth-child(7), td:nth-child(8) { 
      max-width: 50rem; 
    }
  }
}

@media screen and (max-width: 1065px) {
  tbody tr {
    td:nth-child(2), td:nth-child(3), td:nth-child(4) { 
      text-align: left !important; 
    }
    td:nth-child(5), td:nth-child(6) { 
      text-align: left !important; 
      max-width: 50rem; 
    }
  }
}
thead th:nth-child(1),
tbody tr td:nth-child(1) {
  text-align: left !important;
}
</style>